import script from "./lightbox-element.vue?vue&type=script&setup=true&lang=js"
export * from "./lightbox-element.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__